<template>
    <li class="sport__block" v-if="sport">
        <a :href="sport.link">
            
            <figure v-if="sport.sport_thumbnail">
                <span v-html="sport.sport_icon"></span>
                <div v-html="sport.sport_thumbnail"></div>
            </figure>
            
            <h3 class="step--3" v-html="sport.title.rendered"></h3>
        </a>
    </li>
</template>

<script>
    export default {
        props: {
            sport: {
                type: Object,
                required: true
            }
        }
    };
</script>
